module.exports = __webpack_public_path__ + "static/img/panliang.d439c89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/people/panliang.jpg
// module id = alzA
// module chunks = 2